import { hotMatches } from '@/mocks/homeData';

export default function HotMatchesSection() {
  return (
    <section className="relative w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-8 md:mb-10 gap-4">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <i className="ri-fire-line text-accent-500 text-lg"></i>
              <span className="text-sm font-semibold text-accent-600 tracking-wide uppercase">HOT</span>
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 tracking-tight">
              热门即将开赛
            </h2>
          </div>
          <a
            href="/category/sports"
            className="flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            全部赛程 <i className="ri-arrow-right-line text-xs"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 md:gap-5">
          {hotMatches.map((match, idx) => (
            <a
              key={match.id}
              href={`/category/${match.id}`}
              className="group flex items-center gap-4 bg-background-50 border border-background-200 rounded-xl p-4 md:p-5 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs text-foreground-500">{match.league}</span>
                  {match.hotTag && (
                    <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700 whitespace-nowrap">
                      热门
                    </span>
                  )}
                </div>
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-sm font-bold text-foreground-900 truncate">{match.homeTeam}</span>
                  <span className="text-xs text-foreground-400 shrink-0">vs</span>
                  <span className="text-sm font-bold text-foreground-900 truncate">{match.awayTeam}</span>
                </div>
                <span className="text-xs text-foreground-500">
                  <i className="ri-time-line mr-1"></i>{match.startTime}
                </span>
              </div>

              <div className="flex items-center gap-2 shrink-0">
                {'draw' in match.odds ? (
                  <>
                    <div className="w-14 text-center">
                      <span className="block text-xs text-foreground-500 mb-0.5">主胜</span>
                      <span className="block text-sm font-bold text-primary-600 group-hover:text-primary-700">{match.odds.home}</span>
                    </div>
                    <div className="w-14 text-center">
                      <span className="block text-xs text-foreground-500 mb-0.5">平</span>
                      <span className="block text-sm font-bold text-foreground-600">{match.odds.draw}</span>
                    </div>
                    <div className="w-14 text-center">
                      <span className="block text-xs text-foreground-500 mb-0.5">客胜</span>
                      <span className="block text-sm font-bold text-foreground-600">{match.odds.away}</span>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="w-14 text-center">
                      <span className="block text-xs text-foreground-500 mb-0.5">{match.homeTeam}</span>
                      <span className="block text-sm font-bold text-primary-600 group-hover:text-primary-700">{match.odds.home}</span>
                    </div>
                    <div className="w-14 text-center">
                      <span className="block text-xs text-foreground-500 mb-0.5">{match.awayTeam}</span>
                      <span className="block text-sm font-bold text-foreground-600">{match.odds.away}</span>
                    </div>
                  </>
                )}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}